export default __webpack_public_path__ + "46f6de48e819b348a8e6be5beb61c8ee.svg";